import { render, staticRenderFns } from "./newUser_es.vue?vue&type=template&id=7f0eff20&"
import script from "./newUser_es.vue?vue&type=script&lang=js&"
export * from "./newUser_es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports